// extracted by mini-css-extract-plugin
var _1 = "bB2q6";
var _2 = "y_G48";
var _3 = "ACGb5";
var _4 = "_TvEW";
var _5 = "GgHzM";
var _6 = "EmdGf";
var _7 = "h5M4N";
var _8 = "uz227";
var _9 = "rclHC";
var _a = "OiyDj";
export { _1 as "autoCompleteInput", _2 as "autoCompleteOverlay", _3 as "autoCompletePrefix", _4 as "autoCompleteTabHint", _5 as "inSearchInputPlaceholder", _6 as "inputPlaceholder", _7 as "isDisabled", _8 as "searchBoxInput", _9 as "searchBoxInputContainer", _a as "win32SearchBoxInput" }
